import { createSlice } from "@reduxjs/toolkit";
import { fetchAllSecurityGroups, fetchPermissions, getAllGeoLocations, getAllRelationshipTypesApi, removeRelationshipTypesApi } from "../api/common";
import { sendCommunicationRequestApi } from "../api/communication";

interface CommunicationState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
} as CommunicationState;
 export const communicationSlice = createSlice({
    name: 'communication',
    initialState,
    reducers:{
        resetCommunication: () => initialState,
      },
    extraReducers(builder) {
        builder
        .addCase(sendCommunicationRequestApi.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(sendCommunicationRequestApi.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(sendCommunicationRequestApi.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          });
    }
 })

 export const { resetCommunication } = communicationSlice.actions;

export default communicationSlice.reducer;
